import e from "../managers/braze-instance.js";
export function initialize(i, n) {
  return e.initialize(i, n);
}
